export default __webpack_public_path__ + "static/media/frog.d0f156a6.png";